module.exports = __webpack_public_path__ + "/bundle/asset/admission3-2-f961e7ace7c1d8d3a01e892b4f6bd7e8.png";